import React from 'react';
import {
  FaAngleDoubleRight,
  FaArrowRight,
  FaCheckCircle,
} from 'react-icons/fa';
import { Link } from 'react-router-dom';

const TravelIinsuranceDetails = () => {
  return (
    <>
      {/* ===================== Service Details Area start ===================== */}
      <div className="service-area pd-top-120 pd-bottom-90">
        <div className="container">
          <div className="row">
            <div className="col-lg-4 col-12">
              <div className="td-sidebar service-sidebar">
                <div className="widget widget_catagory">
                  <h5 className="widget-title">
                    <FaArrowRight /> All Service lists
                  </h5>
                  <ul className="catagory-items">
                    <li>
                      <Link to="/AirTicketing"> Air Ticketing</Link>
                    </li>
                    <li>
                      <Link to="/TravelInsurance"> Travel Insurance</Link>
                    </li>
                     <li>
                       <Link to="/DomesticInternationalTours"> Domestic & International Tours</Link>
                     </li>
                     <li>
                         <Link to="/MICE"> MICE</Link>
                      </li>
                     <li>
                      <Link to="/PassportVisa"> Passport & Visa Assistance</Link>
                     </li>
                     <li>
                         <Link to="/HotelBooking"> Hotel Booking </Link>
                     </li>
                  </ul>
                </div>
                <div className="widget widget_author text-center">
                  <div className="thumb">
                    <img src="assets/img/about/9.png" alt="img" />
                  </div>
                  
                </div>
               
              </div>
            </div>
            <div className="col-lg-8">
              <div className="blog-details-page-content">
                <div className="single-blog-inner mb-0">
                  <div className="thumb">
                    <img src="assets/img/banner2.jpg" alt="img" />
                  </div>
                  <div className="details">
                    <h4>
                    Secure Your Journey with Comprehensive Travel Insurance
                    </h4>
                    <p>
                    Travel with peace of mind! Our travel insurance plans cover medical emergencies, trip cancellations, lost luggage, and more. Whether you're going 
                    on a short domestic trip or a long international vacation, we've got you covered.
                    </p>
                   
                    
                    <h4>Coverage Includes:</h4>
                   
                    <div className="row">
                      <div className="col-md-12">
                        <ul className="single-list-inner style-check style-check mb-3">
                          <li>
                            <FaCheckCircle /> Medical & Emergency Expenses
                          </li>
                          <li>
                            <FaCheckCircle /> Trip Cancellation or Interruption
                          </li>
                          <li>
                            <FaCheckCircle /> Loss of Passport or Baggage
                          </li>
                          <li>
                            <FaCheckCircle /> Personal Accident Cover
                          </li>
                        </ul>
                      </div>

                      <div className="details">
                    <Link className="btn btn-base border-radius-5" to="tel:6363169466">
                    Affordable plans tailored for every traveler.
                    </Link>
                  </div>
                      
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* ===================== Service Details Area End ===================== */}
    </>
  );
};

export default TravelIinsuranceDetails;
